<template>
  <s-modal
    class="alarm-filtered-assets-modal"
    v-model="showModal"
    size="lg"
    centered
    ok-only
    :title="titleHandler"
    :is-loading="loading"
    @show="refreshAlarmDetails()"
    @ok="closeModal()"
  >
    <b-container fluid>
      <b-row
        v-if="!loading"
        class="alarm-filtered-assets-modal__table-wrapper"
      >
        <s-table
          class="alarm-filtered-assets-modal__table"
          :fields="fields"
          :items="items"
        >
        </s-table>
      </b-row>
      <b-row
        v-else
        align-h="center"
      >
        <s-loader
          size="lg"
          class="my-5"
        />
      </b-row>
      <b-row>
        <grid-paginator
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="perPage"
          @input="paging"
        />
      </b-row>
    </b-container>
  </s-modal>
</template>

<script>
import GridPaginator from '@/components/lists/Paginator';
import AlarmDetailsService from '@/domain/services/generalPanel/adminPanel/alarmConfigurations';
import LoadingMixin from '@/services/loadingMixin';

export default {
  name: 'AlarmFilteredAssetsModal',
  mixins: [LoadingMixin],
  components: {
    GridPaginator,
  },
  data: () => ({
    currentPage: 1,
    totalItems: null,
    perPage: 15,
    items: [],
  }),
  props: {
    value: {
      type: Boolean,
    },
    filter: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    titleHandler() {
      return this.$t('admin-panel.alarm-filtered-assets.title');
    },
    fields() {
      return [
        {
          key: 'companyName',
          label: this.$t('entities.company'),
        },
        {
          key: 'regionalName',
          label: this.$t('entities.regional'),
        },
        {
          key: 'installationName',
          label: this.$t('entities.installation'),
        },
        {
          key: 'assetName',
          label: this.$t('entities.asset'),
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ];
    },
  },
  methods: {
    handleResponse(response = {}) {
      const { total, data } = response;
      this.totalItems = total;
      this.items = data;
    },
    refreshAlarmDetails() {
      const filter = {
        ...this.filter,
        pageSize: this.perPage,
        page: this.currentPage,
      };
      this.startLoading();
      return AlarmDetailsService.getAlarmAssets(filter)
        .then(data => this.handleResponse(data))
        .finally(() => this.endLoading());
    },
    paging(page) {
      this.currentPage = page;
      this.refreshAlarmDetails();
    },
    closeModal() {
      this.showModal = false;
    },
  },

};
</script>
<style lang="sass" scoped>
  .alarm-filtered-assets-modal
    &__table-wrapper
      max-height: 50vh
      overflow-y: auto

</style>
